<template>
  <form-main @back="makeSureBack">
    <template slot="nav">
      <div class="vita-form-nav">
        <p>完善讲师资料<span style="font-size: 16px;color: red;"></span></p>
      </div>
    </template>
    <template slot="main">
      <div class="vita-form-main">
        <div class="content">
          <template v-if="!isLoading">
            <vue-scroll :ops="ops">
              <div class="form-wrap">
                <el-form :model="vitaForm"
                         :rules="rules"
                         ref="vitaForm"
                         label-width="120px"
                         size="medium">
                  <!-- 个人信息 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>个人信息</legend>
                    <el-form-item label-width="100px">
                      <el-row>
                        <el-col :span="9">
                          <!--<vita-card :imgUrl.sync="cardFront"
                                     tips="身份证正面"
                                     @imgChange="cardFrontImgChange"></vita-card>-->
                          <div class="idcard-front-end" :class="{basic_information_forbidden_click:not_allow_change }">
                            <!--<vita-photo :w="260" :dw="'600px'" :h="160"-->
                                        <!--:imgUrl.sync="cardFront" :disabled="not_allow_change"></vita-photo>-->
                            <vita-img ref="vitaImgInfoFront" :imgUrl.sync="cardFront" :w="260" :h="160"  :dw="'600px'" :disabled="not_allow_change " :photoType="'Card'" :cardType="'identify_edit1'"></vita-img>
                            <div v-show="showTipsFront"
                                 class="front-end-tips front-tips">
                              <img :src="tipsFront" alt="">
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="9">
                          <!--<vita-card :imgUrl.sync="cardBack"
                                     tips="身份证反面"
                                     @imgChange="cardBackImgChange"></vita-card>-->
                          <div class="idcard-front-end "  :class="{basic_information_forbidden_click:not_allow_change}">
                            <!--<vita-photo :w="260" :dw="'600px'" :h="160"-->
                                        <!--:imgUrl.sync="cardBack"  :disabled="not_allow_change"></vita-photo>-->
                            <vita-img ref="vitaImgInfoFront" :imgUrl.sync="cardBack" :w="260" :h="160"  :dw="'600px'" :disabled="not_allow_change " :photoType="'Card'" :cardType="'identify_edit2'"></vita-img>
                            <div v-show="showTipsEnd"
                                 class="front-end-tips end-tips">
                              <img :src="tipsEnd" alt="">
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="5" :offset="1">
                          <div class="photo">
                            <vita-img ref="vitaImgInfo" :imgUrl.sync="photo"  :photoType="'photo'" :disabled="not_allow_change" :class="{basic_information_forbidden_click:not_allow_change }"></vita-img>
                            <div v-show="showTipsPhoto"
                                 class="tips-photo">
                              <img :src="tipsPhoto" alt="">
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </el-form-item>
                    <template v-if="!not_allow_change">
                      <el-row>
                        <el-col :span="7">
                          <el-form-item label="姓名" prop="name">
                            <el-input v-model.trim="vitaForm.name"
                                      :disabled="true"
                                      placeholder="请输入姓名"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="7">
                          <el-form-item label="性别"
                                        prop="gender"
                                        class="gender">
                            <el-select v-model="noEdit.gender"
                                       :disabled="true"
                                       style="width: 137px"
                                       placeholder="请选择性别">
                              <el-option
                                      v-for="item in gender"
                                      :key="item.val"
                                      :label="item.key"
                                      :value="item.val">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="10" style="display: flex;align-items: center;height: 37px;padding-left: 35px">
                          <el-switch
                                  v-model="switch_pinyin"
                                  @change="changePinyin"
                          >
                          </el-switch>
                          <span  style="margin-left: 5px">姓名不区分姓氏和名的少数民族学员</span>
                        </el-col>
                      </el-row>
                      <el-row v-if="switch_pinyin">
                        <el-col :span="24">
                          <el-form-item label="姓名(拼音)" prop="family_name_spell">
                            <el-autocomplete
                                    v-if="id_type==='id_number'"
                                    style="width: 100%"
                                    v-model="vitaForm.family_name_spell"
                                    :fetch-suggestions="name_spell_search"
                                    placeholder="姓名不区分姓氏和名的少数民族学员填写,例如巴桑次仁,输入：BASANGCIREN"
                            ></el-autocomplete>
                            <el-input v-else v-model.trim="vitaForm.family_name_spell"
                                      placeholder="姓名不区分姓氏和名的少数民族学员填写,例如巴桑次仁,输入：BASANGCIREN"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row v-else>
                        <el-col :span="12">
                          <el-form-item label="姓氏(拼音)" prop="family_name_spell">
                            <el-autocomplete
                                    v-if="id_type==='id_number'"
                                    style="width: 100%"
                                    v-model="vitaForm.family_name_spell"
                                    :fetch-suggestions="familyNameSearch"
                                    placeholder="请输入拼音大写,例如张三,输入:ZHANG"
                            ></el-autocomplete>
                            <el-input v-else v-model.trim="vitaForm.family_name_spell"

                                      placeholder="请输入拼音大写,例如张三,输入:ZHANG"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="名(拼音)" prop="given_name_spell">
                            <el-autocomplete
                                    v-if="id_type==='id_number'"
                                    style="width: 100%"
                                    v-model="vitaForm.given_name_spell"
                                    :fetch-suggestions="givenNameSearch"
                                    placeholder="请输入拼音大写,例如张三,输入:SAN"
                            ></el-autocomplete>
                            <el-input v-else v-model.trim="vitaForm.given_name_spell"
                                      placeholder="请输入拼音大写,例如张三,输入:SAN"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </template>
                    <template v-else>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="姓名" prop="name">
                            <el-input v-model.trim="vitaForm.name"
                                      :disabled="true"
                                      placeholder="请输入姓名"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="性别"
                                        prop="gender"
                                        class="gender">
                            <el-select v-model="noEdit.gender"
                                       :disabled="true"
                                       style="width: 100%"
                                       placeholder="请选择性别">
                              <el-option
                                      v-for="item in gender"
                                      :key="item.val"
                                      :label="item.key"
                                      :value="item.val">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row v-if="switch_pinyin">
                        <el-col :span="24">
                          <el-form-item label="姓名(拼音)" prop="family_name_spell">
                            <el-autocomplete
                                    v-if="id_type==='id_number'"
                                    style="width: 100%"
                                    v-model="vitaForm.family_name_spell"
                                    :fetch-suggestions="name_spell_search"
                                    :disabled="true"
                                    placeholder="姓名不区分姓氏和名的少数民族学员填写,例如巴桑次仁,输入：BASANGCIREN"
                            ></el-autocomplete>
                            <el-input v-else v-model.trim="vitaForm.family_name_spell"
                                      placeholder="姓名不区分姓氏和名的少数民族学员填写,例如巴桑次仁,输入：BASANGCIREN"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row v-else>
                        <el-col :span="12">
                          <el-form-item label="姓氏(拼音)" prop="family_name_spell">
                            <el-autocomplete
                                    v-if="id_type==='id_number'"
                                    style="width: 100%"
                                    v-model="vitaForm.family_name_spell"
                                    :disabled="true"
                                    :fetch-suggestions="familyNameSearch"
                                    placeholder="请输入拼音大写,例如张三,输入:ZHANG"
                            ></el-autocomplete>
                            <el-input v-else v-model.trim="vitaForm.family_name_spell"

                                      placeholder="请输入拼音大写,例如张三,输入:ZHANG"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="名(拼音)" prop="given_name_spell">
                            <el-autocomplete
                                    v-if="id_type==='id_number'"
                                    style="width: 100%"
                                    v-model="vitaForm.given_name_spell"
                                    :fetch-suggestions="givenNameSearch"
                                    :disabled="true"
                                    placeholder="请输入拼音大写,例如张三,输入:SAN"
                            ></el-autocomplete>
                            <el-input v-else v-model.trim="vitaForm.given_name_spell"
                                      placeholder="请输入拼音大写,例如张三,输入:SAN"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </template>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="曾用名" prop="former_name">
                          <el-input v-model.trim="vitaForm.former_name"
                                    placeholder="请输入曾用名，没有可不填。"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="民族" prop="nation" class="national"
                          :rules="{required: vitaForm.nationality ==='CN', message: `请选择民族`, trigger: `change`}">
                          <el-select v-model="vitaForm.nation"
                                     filterable
                                     placeholder="请选择民族">
                            <el-option
                                    v-for="item in nationArr"
                                    :key="item.nation_zh"
                                    :label="item.nation_zh"
                                    :value="item.nation_zh">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="国籍" prop="nationality" class="national">
                          <el-select v-model="vitaForm.nationality"
                                     filterable
                                     placeholder="请选择国籍">
                            <el-option
                                    v-for="item in countryArr"
                                    :key="item.country_code"
                                    :label="item.country_zh"
                                    :value="item.country_code">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="护照号" prop="passport">
                          <el-input v-model.trim="vitaForm.passport"
                                    placeholder="请输入护照号"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="手机">
                          <el-input v-model="noEdit.phone"
                                    :disabled="true"
                                    placeholder="请输入手机号"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="出生日期"
                                      prop="birthday">
                          <!--<el-form-item label="出生日期"
                                        prop="date_of_birth"
                                        class="birthday">
                            <el-date-picker
                                v-model="vitaForm.date_of_birth"
                                type="date"
                                :disabled="true"
                                placeholder="请选择日期">
                            </el-date-picker>-->
                          <el-date-picker
                                  style="width:100%"
                                  v-model="vitaForm.birthday"
                                  type="date"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="option"
                                  :disabled="!canChangeBirthday "
                                  placeholder="请选择出生日期">
                          </el-date-picker>
                          <!-- <el-input v-model="noEdit.birthDay"
                                    :disabled="true"></el-input> -->
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="10">
                        <el-form-item label="身高" prop="height">
                          <el-input v-model.trim="vitaForm.height"
                                    placeholder="请输入身高(单位/cm)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="2" style="padding: 10px;"><span>cm</span></el-col>
                      <el-col :span="10">
                        <el-form-item label="体重" prop="weight">
                          <el-input v-model.trim="vitaForm.weight"
                                    placeholder="请输入体重(单位/kg)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="2" style="padding: 10px;"><span>kg</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="证件号">
                          <el-input v-model.trim="noEdit.idNum"
                                    :disabled="true"
                                    placeholder="请输入证件号"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="电子邮箱" prop="email_address">
                          <el-autocomplete
                                  class="inline-input"
                                  style="width: 100%"
                                  v-model.trim="vitaForm.email_address"
                                  :fetch-suggestions="querySearch"
                                  :disabled="not_allow_change "
                                  placeholder="请输入电子邮箱"
                                  :trigger-on-focus="false"
                          ></el-autocomplete>
                          <!--                          <el-input v-model.trim="vitaForm.email_address"-->
                          <!--                                    placeholder="电子邮箱信息可用来找回帐号密码"></el-input>-->
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item label="伤病历史">
                      <el-input type="textarea"
                                :rows="1"
                                v-model.trim="vitaForm.medical_history"
                                placeholder="若有伤病史请输入"></el-input>
                    </el-form-item>
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="固定电话" >
                          <el-input v-model.trim="vitaForm.contact_numbers"
                                    placeholder="请输入固定电话"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="邮编(家)" prop="postcode">
                          <el-input v-model.trim="vitaForm.postcode"
                                    placeholder="请输入邮编"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="传真(家)" prop="fax_personage">
                          <el-input v-model.trim="vitaForm.fax_personage"
                                    placeholder="请输入传真"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item label="通信地址(家)">
                      <el-input type="textarea"
                                :rows="1"
                                v-model.trim="vitaForm.contact_address"
                                placeholder="请输入通信地址"></el-input>
                    </el-form-item>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="套服" prop="track_suit">
                          <el-select v-model="vitaForm.track_suit"
                            placeholder="请选择套服尺码">
                            <el-option v-for="item in wearNum" :key="item" :label="item" :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="T恤" prop="polo_T">
                          <el-select v-model="vitaForm.polo_T"
                            placeholder="请选择T恤尺码">
                            <el-option v-for="item in wearNum" :key="item" :label="item" :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="短裤" prop="shorts">
                          <el-select v-model="vitaForm.shorts"
                            placeholder="请选择短裤尺码">
                            <el-option v-for="item in wearNum" :key="item" :label="item" :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="跑步鞋号" prop="track_shoes">
                          <el-select v-model="vitaForm.track_shoes"
                            placeholder="请选择跑步鞋号">
                            <el-option v-for="item in shoesNum" :key="item" :label="item" :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </fieldset>

                  <!-- 当前执教场所 -->
                  <!--<fieldset class="vita-form-fieldset">-->
                    <!--<legend>当前执教场所</legend>-->
                    <!--<div class="block" style="margin-bottom: 15px">-->
                      <!--<el-form-item label="当前是否存在执教场所" label-width="200px">-->
                        <!--<el-switch-->
                                <!--v-model="isTackPalceExit"-->
                                <!--active-text="是"-->
                                <!--inactive-text="否"-->
                                <!--@change="isTackPalceExitChange"-->
                        <!--&gt;</el-switch>-->
                      <!--</el-form-item>-->
                      <!--<el-form-item v-show="isTackPalceExit" label="执教场所" prop="take_place">-->
                        <!--<el-cascader-->
                                <!--:options="take_place"-->
                                <!--placeholder="请选择执教场所"-->
                                <!--propper-class="my-wrapper-q"-->
                                <!--v-model="vitaForm.take_place"-->
                                <!--ref="cas"-->
                                <!--:props="cascaderProps"-->
                                <!--:popper-class="'double_line_cascader'"-->
                                <!--clearable-->
                                <!--:disabled="!isTackPalceExit"-->
                        <!--&gt;</el-cascader>-->
                      <!--</el-form-item>-->
                    <!--</div>-->
                  <!--</fieldset>-->
                  <fieldset class="vita-form-fieldset">
                    <legend>现执教情况</legend>
    
                    <el-row>
                      <el-col :span="12">
                        <el-form-item
                          label="现执教单位"
                          prop="take_unit"
                        >
                          <el-select
                            v-model="vitaForm.take_unit"
                            placeholder="请选择执教单位"
                          >
                            <el-option
                              v-for="item in take_unit_list"
                              :key="item.value"
                              :label="item.value"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                          <!-- @change="changes" -->
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="队伍年龄" prop="team_age" v-if="!['其他','未在执教'].includes(vitaForm.take_unit)">
                          <el-select
                            v-model="vitaForm.team_age"
                            placeholder="请选择队伍年龄"
                          >
                            <el-option
                              v-for="item in team_age_list"
                              :key="item.value"
                              :label="item.value"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="队伍性别" prop="team_sex" v-if="!['其他','未在执教'].includes(vitaForm.take_unit)">
                          <el-select
                            v-model="vitaForm.team_sex"
                            placeholder="请选择队伍性别"
                          >
                            <el-option label="男子" value="男子"></el-option>
                            <el-option label="女子" value="女子"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="职务" prop="take_job" v-if="!['其他','未在执教'].includes(vitaForm.take_unit)">
                          <el-select
                            v-model="vitaForm.take_job"
                            placeholder="请选择职务"
                          >
                            <el-option
                              v-for="item in take_job_list"
                              :key="item.value"
                              :label="item.value"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item label="单位名称" prop="take_unit_name">
                      <el-input
                        v-model.trim="vitaForm.take_unit_name"
                        placeholder="请填写单位名称，如无工作单位请填写“无”"
                      ></el-input>
                    </el-form-item>
  
                  </fieldset>
                  <!-- 最高学历 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>学历(请填写您的最高学历，也可添加多个)</legend>
                    <el-row v-for="(col, index) in vitaForm.academic_qualification"
                            :key="index"
                            class="vita-edu-row">
                      <el-col :span="21">
                        <!--<el-form-item label="起止日期">-->
                          <!--<el-date-picker-->
                                  <!--v-model="col.time"-->
                                  <!--@change="changeEduTime(index)"-->
                                  <!--type="daterange"-->
                                  <!--range-separator="至"-->
                                  <!--start-placeholder="开始日期"-->
                                  <!--end-placeholder="结束日期">-->
                          <!--</el-date-picker>-->
                        <!--</el-form-item>-->
                        
                        <el-row>
                          <el-col :span="8">
                            <el-form-item label="开始日期"  :prop="`academic_qualification.${index}.academic_start_date`" :rules="[requiredItem('开始日期', true)]">
                              <el-date-picker
                                v-model="col.academic_start_date"
                                type="month"
                                @focus="datePickerOfStart(col)"
                                :picker-options="pickerOptionsStart"
                                placeholder="选择日期"
                                :value-format="'yyyy-MM'"
                                style="width:150px">
                                <!--pickerOptionsStart-->
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                          <el-col :span="16">
                            <el-form-item label="截止日期" label-width="156px" :prop="`academic_qualification.${index}.academic_end_date`" :rules="col.zhijin === 'Y' ? [] : [requiredItem('截止日期', true)]">
    
                              <el-switch
                                v-model="col.zhijin"
                                active-text="选择日期"
                                active-value="N"
                                inactive-text="至今"
                                inactive-value="Y"
                                @change="isZhijinChange(col.zhijin)"
                              ></el-switch>
                              <el-date-picker
                                v-model="col.academic_end_date"
                                type="month"
                                @focus="datePickerOfEnd(col)"
                                :picker-options="pickerOptionsEnd"
                                placeholder="选择日期"
                                :value-format="'yyyy-MM'"
                                v-if="col.zhijin === 'N'"
                                style="width:150px;margin-left:20px">
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="地点" :prop="`academic_qualification.${index}.academic_address`" :rules="[requiredItem('地点')]">
                                 <el-input v-model.trim="col.academic_address"
                                        placeholder="请输入地点"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="学校"
                                          :prop="'academic_qualification.' + index + '.academic_venue'"
                                          :rules="{required: true, message: '学校不能为空',trigger: 'blur',}">
                              <el-input v-model.trim="col.academic_venue"
                                        placeholder="请输入学校"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <el-form-item label="学历/职称"
                                          :prop="'academic_qualification.' + index + '.qualification'"
                                          :rules="{required: true, message: '学历/职称不能为空',trigger: 'change',}">
                              <el-select v-model="col.qualification" placeholder="请选择学历/职称" >
                                <el-option
                                        v-for="item in qualificationList"
                                        :key="item.key"
                                        :label="item.key"
                                        :value="item.value" >
                                </el-option>
                              </el-select>
                              <!-- <el-input v-model.trim="col.qualification"
                                        placeholder="请选择学历/职称"></el-input> -->
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="证明人">
                              <el-input v-model.trim="col.references_man"
                                        placeholder="请输入证明人"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="联系方式">
                              <el-input v-model.trim="col.contact_details"
                                        placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row >
                          <el-col :span="12" v-if="['本科','硕士','博士'].includes(col.qualification)">
                            <el-form-item
                              label="学历证书编号"
                              style="margin-bottom:5px"
                            >
                              <el-input
                                v-model.trim="col.academic_number"
                                placeholder="请输入学历证书编号"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item
                              label="否是足球专项专业"
                              label-width="150px"
                              :prop="
                                'academic_qualification.' +
                                index +
                                '.is_football'
                              "
                              :rules="[requiredItem('足球专项','change')]"
                              style="margin-bottom:5px"
                            >
                              <el-radio-group v-model="col.is_football">
                                <el-radio :label=0 border>否</el-radio>
                                <el-radio :label=1 border>是</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </el-col>
                          <span style="margin: 5px 25px;color: #f88594;" v-if="['本科','硕士','博士'].includes(col.qualification)">请报名B级及以上等级培训的学员完善此信息，便于验证真伪。学历证书编号可在学信网查询，<a href="https://www.chsi.com.cn/xlcx/index.jsp" style="color:#4CD964;cursor:pointer;" target="_black">点击查询</a></span>
                        </el-row>
                        <el-row :gutter="10" v-if="['本科','硕士','博士'].includes(col.qualification)">
                          <el-col :span="24">
                            <el-form-item label="学历证明文件">
                              <el-row :gutter="10">
                                <el-col :span="12">
                                  <el-upload
                                    action="/api/enroll/upload_enroll_file.json"
                                    :headers="fileUpHeaders"
                                    :file-list="col.work_certificate_list"
                                    :data="fileUpParam"
                                    :limit="1"
                                    :before-upload="beforeUpload"
                                    :on-remove="
                                      (file, fileList) =>
                                        handleRemoveFile(
                                          'academic_qualification',
                                          index,
                                          file,
                                          fileList
                                        )
                                    "
                                    :on-exceed="(file,  fileList) =>
                                      handleOnExceed(
                                          'academic_qualification',
                                          index,
                                          file,
                                          fileList)
                                    "
                                    :on-success="
                                      (res, file) =>
                                        handleSuccessFile(
                                          'academic_qualification',
                                          index,
                                          res,
                                          file
                                        )
                                    "
                                  >
                                    <el-button type="primary" title=""
                                    >点击上传</el-button
                                    >
                                    <div slot="tip" class>请报名B级及以上等级培训的学员上传学历证明PDF文件，便于验证真伪。文件大小不能超过50M</div>
                                  </el-upload>
                                </el-col>
                                <el-col :span="10" v-if="col.work_certificate">
                                  <a
                                    :href="col.work_certificate"
                                    target="_black"
                                  ><el-button type="primary"
                                  >查看文件</el-button
                                  ></a
                                  >
                                </el-col>
                              </el-row>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="3">
                        <el-row class="exp-opt">
                          <el-col :span="6"
                                  :offset="6">
                            <el-button type="primary"
                                       size="small"
                                       icon="el-icon-plus"
                                       @click="addEducationExp"
                                       circle></el-button>
                          </el-col>
                          <el-col :span="8"
                                  :offset="4">
                            <el-button v-show="vitaForm.academic_qualification.length !== 1"
                                       type="danger"
                                       size="small"
                                       icon="el-icon-minus"
                                       @click="delEducationExp(index)"
                                       circle></el-button>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </fieldset>
                  <!-- 外语 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>外语</legend>
                    <el-row
                    >
                      <el-col :span="24">
                        <el-row>
                          <el-col :span="13">
                            <!--<el-form-item label="语种"
                              label-width="50px"
                              :prop="'language_row.' + index + '.language'"
                              :rules="{
                                validator: (rule, value, callback)=>languageValidate(rule, value, callback, index),
                                trigger: 'change'
                              }">-->
                            <el-form-item label="英语能力" label-width="80px" prop="english_ability"
                              :rules="[requiredItem('英语能力','change')]">
                              <el-select
                                v-model="vitaForm.english_ability"
                                filterable
                                clearable
                                placeholder="请选择英语能力"
                                style="width:380px"
                              >
                                <el-option
                                  v-for="item in EnglishAbility"
                                  :key="item.value"
                                  :label="item.key"
                                  :value="item.value"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="11" v-if="['basic','good'].includes(vitaForm.english_ability) && vitaForm.english_ability">
                            <el-form-item
                              label="成绩报告单编号"
                              label-width="160px"
                              style="margin-bottom:0"
                            >
                              <el-input
                                v-model.trim="vitaForm.english_ability_number"
                                placeholder="请输入成绩报告单编号"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <span style="margin-left: 20px;color: #f88594;" v-if="['basic','good'].includes(vitaForm.english_ability) && vitaForm.english_ability">成绩报告单编号可在中国教育考试网进行查询，<a href="https://cjcx.neea.edu.cn/html1/folder/22031/2973-1.htm" style="color:#4CD964;cursor:pointer;" target="_black">点击查询</a></span>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24" v-if="!['none','simple'].includes(vitaForm.english_ability) && vitaForm.english_ability">
                        <el-form-item label="英语能力证明文件">
                          <el-row :gutter="10">
                            <el-col :span="12">
                              <el-upload
                                action="/api/enroll/upload_enroll_file.json"
                                :headers="fileUpHeaders"
                                :file-list="vitaForm.english_file_list"
                                :data="fileUpParam"
                                :limit="1"
                                :before-upload="beforeUploadEnglish"
                                :on-remove="
                                      (file, fileList) =>
                                        handleRemoveFileEnglish(
                                          file,
                                          fileList
                                        )
                                    "
                                :on-exceed="(file,  fileList) =>
                                      handleOnExceedEnglish(
                                          file,
                                          fileList)
                                    "
                                :on-success="
                                      (res, file) =>
                                        handleSuccessFileEnglish(
                                          res,
                                          file
                                        )
                                    "
                              >
                                <el-button type="primary"
                                >点击上传</el-button
                                >
                                <div slot="tip" class>请报名B级及以上等级培训的学员上传50M以内的PDF英语能力证明文件，便于验证真伪
                                  <span v-if="['best','very_best'].includes(vitaForm.english_ability) && vitaForm.english_ability">；例如：托福雅思成绩、专业英语成绩、海外留学证明或者学历等</span>
                                  <span v-if="['good','basic'].includes(vitaForm.english_ability) && vitaForm.english_ability">；例如：全国大学英语四、六级考试成绩证书</span>
                                </div>
                              </el-upload>
                            </el-col>
                            <el-col :span="4" v-if="vitaForm.english_file">
                              <a
                                :href="vitaForm.english_file"
                                target="_black"
                              ><el-button type="primary"
                              >查看文件</el-button
                              ></a
                              >
                            </el-col>
                          </el-row>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-for="(col, index) in vitaForm.language_row" :key="index">
                      <el-col :span="6">
                        <!--<el-form-item label="语种"
                                      label-width="50px"
                                      :prop="'language_row.' + index + '.language'"
                                      :rules="{
                                        validator: (rule, value, callback)=>languageValidate(rule, value, callback, index),
                                        trigger: 'change'
                                      }">-->
                        <el-form-item label="其他语种"
                                      label-width="80px">
                          <el-select v-model="col.language_ids"
                                     filterable
                                     clearable
                                     placeholder="请选择语种">
                            <el-option
                                    v-for="item in languageArr"
                                    :key="item.language_id"
                                    :label="item.zh"
                                    :value="item.language_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6"
                              :offset="1">
                        <!--<el-form-item label="口语"
                                      label-width="40px"
                                      :prop="'language_row.' + index + '.spoken'"
                                      :rules="{
                                        validator: (rule, value, callback)=>spokenValidate(rule, value, callback, index),
                                        trigger: 'change'
                                      }">-->
                        <el-form-item label="口语"
                                      label-width="40px">
                          <el-select v-model="col.spoken"
                                     clearable
                                     placeholder="请选择口语熟练度">
                            <el-option
                                    v-for="item in language_level"
                                    :key="item.val"
                                    :label="item.key"
                                    :value="item.val">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6"
                              :offset="1">
                        <!--<el-form-item label="书写"
                                      label-width="40px"
                                      :prop="'language_row.' + index + '.written'"
                                      :rules="{
                                        validator: (rule, value, callback)=>writtenValidate(rule, value, callback, index),
                                        trigger: 'change'
                                      }">-->
                        <el-form-item label="书写"
                                      label-width="40px">
                          <el-select v-model="col.written"
                                     clearable
                                     placeholder="请选择书写熟练度">
                            <el-option
                                    v-for="item in language_level"
                                    :key="item.val"
                                    :label="item.key"
                                    :value="item.val">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="1"
                              :offset="1">
                        <el-button type="primary"
                                   size="small"
                                   icon="el-icon-plus"
                                   @click="addLanguage"
                                   circle></el-button>
                      </el-col>
                      <el-col :span="1"
                              :offset="1">
                        <el-button v-show="vitaForm.language_row.length !== 1"
                                   type="danger"
                                   size="small"
                                   icon="el-icon-minus"
                                   @click="delLanguage(index)"
                                   circle></el-button>
                      </el-col>
                    </el-row>
                  </fieldset>

                  <!-- 单位信息 -->
                  <!-- <fieldset class="vita-form-fieldset">
                    <legend>单位信息</legend>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="单位名称">
                          <el-input v-model.trim="vitaForm.club_name"
                                    placeholder="请输入单位名称"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="单位邮编" prop="club_postcode">
                          <el-input v-model.trim="vitaForm.club_postcode"
                                    placeholder="请输入单位邮编"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item label="单位地址">
                      <el-input type="textarea"
                                :rows="1"
                                placeholder="请输入单位地址"
                                v-model.trim="vitaForm.club_address"></el-input>
                    </el-form-item>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="电话" prop="club_telephone">
                          <el-input v-model.trim="vitaForm.club_telephone"
                                    placeholder="请输入单位电话"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="传真" prop="club_fax">
                          <el-input v-model.trim="vitaForm.club_fax"
                                    placeholder="请输入单位传真"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="网址">
                          <el-input v-model.trim="vitaForm.club_website"
                                    placeholder="请输入单位网址"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="电子邮箱" prop="club_email">
                          <el-input v-model.trim="vitaForm.club_email"
                                    placeholder="请输入单位电子邮箱"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </fieldset> -->

                  <!-- 装备尺码 -->
                  <!--<fieldset class="vita-form-fieldset">-->
                    <!--<legend>装备尺码</legend>-->
                    <!--<el-row>-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="套服" prop="track_suit">-->
                          <!--<el-select v-model="vitaForm.track_suit"-->
                                     <!--placeholder="请选择套服尺码">-->
                            <!--<el-option v-for="item in wearNum" :key="item" :label="item" :value="item"></el-option>-->
                          <!--</el-select>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="T恤" prop="polo_T">-->
                          <!--<el-select v-model="vitaForm.polo_T"-->
                                     <!--placeholder="请选择T恤尺码">-->
                            <!--<el-option v-for="item in wearNum" :key="item" :label="item" :value="item"></el-option>-->
                          <!--</el-select>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                    <!--</el-row>-->
                    <!--<el-row>-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="短裤" prop="shorts">-->
                          <!--<el-select v-model="vitaForm.shorts"-->
                                     <!--placeholder="请选择短裤尺码">-->
                            <!--<el-option v-for="item in wearNum" :key="item" :label="item" :value="item"></el-option>-->
                          <!--</el-select>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="跑步鞋号" prop="track_shoes">-->
                          <!--<el-select v-model="vitaForm.track_shoes"-->
                                     <!--placeholder="请选择跑步鞋号">-->
                            <!--<el-option v-for="item in shoesNum" :key="item" :label="item" :value="item"></el-option>-->
                          <!--</el-select>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                    <!--</el-row>-->
                  <!--</fieldset>-->

                  <!-- 是否运动经历 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>运动经历</legend>
                    <div class="block" style="display:flex">
                      <el-form-item label="是否存在运动经历" label-width="165px">
                        <el-switch
                                v-model="isSportExperienceExit"
                                active-text="是"
                                inactive-text="否"
                                @change="isSportExperienceChange"
                        ></el-switch>
                      </el-form-item>
                      <el-form-item v-show="isSportExperienceExit" label="最高级别运动经历" label-width="265px" prop="sport_experience_new" :rules="[requiredItem('运动经历','change')]">
                        <el-select
                          v-model="vitaForm.sport_experience_new"
                          clearable
                          placeholder="请选择最高级别运动经历"
                          style="width:284px"
                        >
                          <el-option
                            v-for="item in experienceNew"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <!--<el-cascader-->
                                <!--:options="sport_experience_male"-->
                                <!--placeholder="请选择运动经历"-->
                                <!--propper-class="my-wrapper-q"-->
                                <!--v-model="vitaForm.sport_experience"-->
                                <!--:props="cascaderProps"-->
                                <!--:popper-class="'double_line_cascader'"-->
                                <!--clearable-->
                                <!--:disabled="!isSportExperienceExit"-->
                        <!--&gt;</el-cascader>-->
                      </el-form-item>
                    </div>
                    <div class="block" style="display:flex">
                      <el-form-item
                        v-show="isSportExperienceExit"
                        label="场上位置是否为守门员"
                        label-width="165px"
                        prop="is_goalkeeper"
                        :rules="isSportExperienceExit ? [requiredItem('该项','change')] : []"
                      >
                        <el-radio-group v-model="vitaForm.is_goalkeeper">
                          <el-radio label="否" border>否</el-radio>
                          <el-radio label="是" border>是</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="最高级别正式比赛出场次数"
                        v-if="isSportExperienceExit && ['国家一线队','顶级职业联赛（中超/女超/海外顶级联赛）','第二级别联赛（中甲/女甲/海外次级别联赛）','第三级别联赛（中乙/女乙/海外第三级别联赛）','五人制职业联赛（五超/女五）','五人制第二级别联赛（五甲）'].includes(vitaForm.sport_experience_new)"
                        label-width="204px"
                        prop="highest_experience_record"
                        :rules="(isSportExperienceExit && ['国家一线队','顶级职业联赛（中超/女超/海外顶级联赛）','第二级别联赛（中甲/女甲/海外次级别联赛）','第三级别联赛（中乙/女乙/海外第三级别联赛）','五人制职业联赛（五超/女五）','五人制第二级别联赛（五甲）'].includes(vitaForm.sport_experience_new)) ? [{required: true,message: '该项为必填项，请输入数字',trigger: 'blur',},] : []">
                        <el-input
                          v-model.number.trim="vitaForm.highest_experience_record"
                          style="width: 258px;"
                          @input="changeValue"
                          placeholder="请输入最高正式比赛出场次数"
                        ></el-input>
                        场
                      </el-form-item>
                    </div>
                  </fieldset>
                  <!-- 运动经历  v-if="isReload" -->
                  <fieldset class="vita-form-fieldset" v-show="isSportExperienceExit">
                    <legend>主要运动经历(请详细填写您的运动经历，可添加多个)</legend>
                    <el-row v-for="(col, index) in vitaForm.playing_experience"
                            :key="index"
                            class="vita-edu-row">
                      <el-col :span="21">
                        <!--<el-form-item label="起止日期">-->
                          <!--<el-date-picker-->
                                  <!--v-model="col.time"-->
                                  <!--@change="changeSportTime(index)"-->
                                  <!--type="daterange"-->
                                  <!--range-separator="至"-->
                                  <!--start-placeholder="开始日期"-->
                                  <!--end-placeholder="结束日期">-->
                          <!--</el-date-picker>-->
                        <!--</el-form-item>-->
  
                        <el-row>
                          <el-col :span="8">
                            <el-form-item label="开始日期" :prop="`playing_experience.${index}.play_start_date`"  :rules="isSportExperienceExit ? [requiredItem('开始日期')] : []">
                              <el-date-picker
                                v-model="col.play_start_date"
                                type="month"
                                @focus="datePickerOfStart(col)"
                                :picker-options="pickerOptionsStart"
                                placeholder="选择日期"
                                :value-format="'yyyy-MM'"
                                style="width:150px">
                                <!--pickerOptionsStart-->
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                          <el-col :span="16">
                            <el-form-item label="截止日期" label-width="156px" :prop="`playing_experience.${index}.play_end_date`" :rules="(col.zhijin === 'N'&&isSportExperienceExit) ? [requiredItem('截止日期', 'change')] : []">
    
                              <el-switch
                                v-model="col.zhijin"
                                active-text="选择日期"
                                active-value="N"
                                inactive-text="至今"
                                inactive-value="Y"
                                @change="isZhijinChange(col.zhijin)"
                              ></el-switch>
                              <el-date-picker
                                v-model="col.play_end_date"
                                type="month"
                                @focus="datePickerOfEnd(col)"
                                :picker-options="pickerOptionsEnd"
                                placeholder="选择日期"
                                :value-format="'yyyy-MM'"
                                v-if="col.zhijin==='N'"
                                style="width:150px;margin-left:20px">
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="地点" :prop="`playing_experience.${index}.play_address`"  :rules="isSportExperienceExit ? [requiredItem('地点')] : []">
                              <el-input v-model.trim="col.play_address"
                                        placeholder="请输入地点"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item
                                    label="所在球队"
                                    :prop="'playing_experience.' + index + '.play_team'"
                                    :rules="isSportExperienceExit ? [{required: true, message: '球队不能为空',trigger: 'blur'}] : []"
                            >
                              <el-input v-model.trim="col.play_team"
                                        placeholder="请输入所在球队"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <el-form-item
                                    label="球队级别"
                                    :prop="'playing_experience.' + index + '.play_team_level'"
                                    :rules="isSportExperienceExit ? [{required: true, message: '级别不能为空',trigger: 'change'}] : []"
                            >
                              <el-select v-model="col.play_team_level"
                                         placeholder="请选择球队级别">
                                <el-option v-for="item in teamList" :key="item.key" :label="item.key" :value="item.value"></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="主教练" :prop="`playing_experience.${index}.play_references`" :rules="isSportExperienceExit ? [requiredItem('主教练')] : []">
                              <el-input v-model.trim="col.play_references"
                                        placeholder="请输入主教练"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="联系方式">
                              <el-input v-model.trim="col.play_contact_details"
                                        placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="24">
                            <el-form-item label="主要成绩">
                              <el-input v-model.trim="col.play_achievements"
                                        placeholder="请输入主要成绩" maxlength="200" ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="3">
                        <el-row class="exp-opt">
                          <el-col :span="6"
                                  :offset="6">
                            <el-button type="primary"
                                       size="small"
                                       icon="el-icon-plus"
                                       @click="addSportExp"
                                       circle></el-button>
                          </el-col>
                          <el-col :span="8"
                                  :offset="4">
                            <el-button v-show="vitaForm.playing_experience.length !== 1"
                                       type="danger"
                                       size="small"
                                       icon="el-icon-minus"
                                       @click="delSportExp(index)"
                                       circle></el-button>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </fieldset>

                  <!-- 执教经历 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>执教经历</legend>
                    <div class="block" style="margin-bottom: 15px">
                      <el-form-item label="是否存在执教经历" label-width="200px">
                        <el-switch
                                v-model="isCoachExperienceExit"
                                active-text="是"
                                inactive-text="否"
                                @change="isCoachExperienceChange"
                        ></el-switch>
                      </el-form-item>
                      <el-form-item v-show="isCoachExperienceExit" label="执教经历" prop="coach_experience">
                        <el-cascader
                                :options="options"
                                placeholder="请选择执教经历"
                                propper-class="my-wrapper-q"
                                v-model="vitaForm.coach_experience"
                                :props="cascaderProps"
                                clearable
                                :popper-class="'three_line_cascader'"
                                :disabled="!isCoachExperienceExit"
                        ></el-cascader>
                      </el-form-item>
                    </div>
                  </fieldset>

                  <!-- 主要执教经历 v-if="isReload" -->
                  <fieldset class="vita-form-fieldset"  v-show="isCoachExperienceExit">
                    <legend>主要执教经历(请详细填写您的执教经历，可添加多个)</legend>
                    <el-row v-for="(col, index) in vitaForm.coaching_Experience"
                            :key="index"
                            class="vita-edu-row">
                      <el-col :span="21">
  
                        <el-row>
                          <el-col :span="8">
                            <el-form-item label="开始日期" :prop="`coaching_Experience.${index}.coach_start_date`" :rules="isCoachExperienceExit ? [requiredItem('开始日期')] : []">
                              <el-date-picker
                                v-model="col.coach_start_date"
                                type="month"
                                @focus="datePickerOfStart(col)"
                                :picker-options="pickerOptionsStart"
                                placeholder="选择日期"
                                :value-format="'yyyy-MM'"
                                style="width:150px">
                                <!--pickerOptionsStart-->
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                          <el-col :span="16">
                            <el-form-item label="截止日期" label-width="156px" :prop="`coaching_Experience.${index}.coach_end_date`" :rules="(col.zhijin === 'N'&&isCoachExperienceExit) ? [requiredItem('截止日期', true)] : []">
    
                              <el-switch
                                v-model="col.zhijin"
                                active-text="选择日期"
                                active-value="N"
                                inactive-text="至今"
                                inactive-value="Y"
                                @change="isZhijinChange(col.zhijin)"
                              ></el-switch>
                              <el-date-picker
                                v-model="col.coach_end_date"
                                type="month"
                                @focus="datePickerOfEnd(col)"
                                :picker-options="pickerOptionsEnd"
                                placeholder="选择日期"
                                :value-format="'yyyy-MM'"
                                v-if="col.zhijin === 'N'"
                                style="width:150px;margin-left:20px">
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
  
                        <!--<el-form-item label="起止日期">-->
                          <!--<el-date-picker-->
                                  <!--v-model="col.time"-->
                                  <!--@change="changeTeaTime(index)"-->
                                  <!--type="daterange"-->
                                  <!--range-separator="至"-->
                                  <!--start-placeholder="开始日期"-->
                                  <!--end-placeholder="结束日期">-->
                          <!--</el-date-picker>-->
                        <!--</el-form-item>-->
                        
                        
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="地点" :prop="`coaching_Experience.${index}.coach_address`" :rules="isCoachExperienceExit ? [requiredItem('地点')]: []">
                              <el-input v-model.trim="col.coach_address"
                                        placeholder="请输入地点"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="单位名称" :prop="isCoachExperienceExit ? `coaching_Experience.${index}.unit_name` : ''" :rules="isCoachExperienceExit ? [requiredItem('单位名称')]: []">
                              <el-input v-model="col.unit_name"
                                placeholder="请输入单位名称"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item
                              label="执教球队"
                              :prop="'coaching_Experience.' +
                                    index +
                                    '.coach_team'"
                              :rules="
                                isCoachExperienceExit
                                  ? [
                                      {
                                        required: true,
                                        message: '执教球队不能为空',
                                        trigger: 'change',
                                      },
                                    ]
                                  : []
                              "
                            >
                              <!--<el-input v-model.trim="col.coach_team"-->
                                        <!--placeholder="请输入执教球队"></el-input>-->
                              <el-select
                                v-model="col.coach_team"
                                placeholder="请选择执教球队"
                                @change="changeType(col.coach_team, index)"
                                style="width: 100%;"
                              >
                                <el-option
                                  v-for="item in coach_experience_new"
                                  :key="item.value"
                                  :label="item.value"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          
                          <el-col :span="12">
                            <el-form-item label="参赛级别" :prop="isCoachExperienceExit ? `coaching_Experience.${index}.team_level` : ''" :rules="isCoachExperienceExit ? [requiredItem('参赛级别', true)]: []">
                              <!-- <el-input v-model="col.team_level"
                                placeholder="请选择级别"></el-input> -->
                              <el-select
                                v-model="col.team_level"
                                placeholder="请选择球队参赛级别"
                                :disabled="!Boolean(col.coach_team)"
                                style="width: 100%;"
                              >
                                <el-option
                                  v-for="item in getLevelList(col.coach_team)"
                                  :key="item.value"
                                  :label="item.value"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item
                                    label="职务"
                                    :prop="'coaching_Experience.' + index + '.coach_position'"
                                    :rules="isCoachExperienceExit ? [{required: true, message: '职务不能为空',trigger: 'change'}] : []"
                            >
                              <!--<el-input v-model.trim="col.coach_position"-->
                                        <!--placeholder="请输入职务"></el-input>-->
                              <el-select
                                v-model="col.coach_position"
                                placeholder="请选择职务"
                                style="width: 100%;"
                              >
                                <el-option
                                  v-for="item in coach_position_list"
                                  :key="item.value"
                                  :label="item.value"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="证明人" :prop="`coaching_Experience.${index}.coach_references`" :rules="isCoachExperienceExit ? [requiredItem('证明人')] : []">
                              <el-input v-model.trim="col.coach_references"
                                        placeholder="请输入证明人"></el-input>
                            </el-form-item>
                          </el-col>
                           <el-col :span="12">
                            <el-form-item label="证明人职务">
                              <el-input v-model="col.references_position"
                                placeholder="请选择证明人职务"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="联系方式">
                              <el-input v-model.trim="col.coach_contact_details"
                                        placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="24">
                            <el-form-item label="主要成绩">
                              <el-input v-model.trim="col.coach_achievements"
                                        placeholder="请输入主要成绩" maxlength="200"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        
                        <el-row :gutter="10">
                          <el-col :span="24">
                            <el-form-item label="工作证明">
                              <el-row :gutter="10">
                                <el-col :span="12">
                                  <el-upload
                                    action="/api/enroll/upload_enroll_file.json"
                                    :headers="fileUpHeaders"
                                    :file-list="col.work_certificate_list"
                                    :data="fileUpParam"
                                    :limit="1"
                                    :before-upload="beforeUpload"
                                    :on-remove="
                                      (file, fileList) =>
                                        handleRemoveFile(
                                          'coaching_Experience',
                                          index,
                                          file,
                                          fileList
                                        )
                                    "
                                    :on-exceed="(file,  fileList) =>
                                      handleOnExceed(
                                          'coaching_Experience',
                                          index,
                                          file,
                                          fileList)
                                    "
                                    :on-success="
                                      (res, file) =>
                                        handleSuccessFile(
                                          'coaching_Experience',
                                          index,
                                          res,
                                          file
                                        )
                                    "
                                  >
                                    <el-button type="primary" title="为便于报名更高级别的教练员培训课程，请上传证明文件"
                                      >点击上传</el-button
                                    >
                                    <div slot="tip" class>请先<a href="/uploads/import_tpl/在职证明模板.docx" style="color: #4cd964" download="在职证明模板">下载在职证明模板</a>填写后上传，只能上传一个加盖公章后的PDF文件，且文件大小不能超过50M。（<a href="/uploads/import_tpl/在职证明示例.pdf" style="color: #4cd964" target="_blank">示例</a>）</div>
                                  </el-upload>
                                </el-col>
                                <el-col :span="10" v-if="col.work_certificate">
                                  <a
                                    :href="col.work_certificate"
                                    target="_black"
                                    ><el-button type="primary"
                                      >查看文件</el-button
                                    ></a
                                  >
                                </el-col>
                              </el-row>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="3">
                        <el-row class="exp-opt">
                          <el-col :span="6"
                                  :offset="6">
                            <el-button type="primary"
                                       size="small"
                                       icon="el-icon-plus"
                                       @click="addTeaExp"
                                       circle></el-button>
                          </el-col>
                          <el-col :span="8"
                                  :offset="4">
                            <el-button v-show="vitaForm.coaching_Experience.length !== 1"
                                       type="danger"
                                       size="small"
                                       icon="el-icon-minus"
                                       @click="delTeaExp(index)"
                                       circle></el-button>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </fieldset>

                  <!-- 其他工作经历 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>其他非执教工作经历</legend>
                    <div class="block" style="margin-bottom: 15px">
                      <el-form-item
                        label="是否存在其他非执教工作经历"
                        label-width="200px"
                      >
                        <el-switch
                          v-model="isCoachExperienceNotExit"
                          active-text="是"
                          inactive-text="否"
                          @change="isCoachExperienceNotChange"
                        ></el-switch>
                      </el-form-item>
                    </div>
                  </fieldset>
                  
                  <!-- 其他工作经历  v-if="isReload" -->
                  <fieldset class="vita-form-fieldset" v-show="isCoachExperienceNotExit">
                    <legend>
                      其他非执教工作经历(请详细填写您的其他非执教工作经历，可添加多个)
                    </legend>
                    <el-row
                      v-for="(col, index) in vitaForm.coaching_Experience_not"
                      :key="index"
                      class="vita-edu-row"
                    >
                      <el-col :span="21">
                        <el-row>
                          <el-col :span="8">
                            <el-form-item label="开始日期" :prop="`coaching_Experience_not.${index}.coach_start_date`" :rules="isCoachExperienceNotExit ? [requiredItem('开始日期')] : []">
                              <el-date-picker
                                v-model="col.coach_start_date"
                                type="month"
                                @focus="datePickerOfStart(col)"
                                :picker-options="pickerOptionsStart"
                                placeholder="选择日期"
                                :value-format="'yyyy-MM'"
                                style="width:150px"
                              >
                                <!--pickerOptionsStart-->
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                          <el-col :span="16">
                            <el-form-item label="截止日期" label-width="156px"  :prop="`coaching_Experience_not.${index}.coach_end_date`" :rules="(col.zhijin === 'N'&&isCoachExperienceNotExit) ? [requiredItem('截止日期', true)] : []">
    
                              <el-switch
                                v-model="col.zhijin"
                                active-text="选择日期"
                                active-value="N"
                                inactive-text="至今"
                                inactive-value="Y"
                                @change="isZhijinChange(col.zhijin)"
                              ></el-switch>
                              <el-date-picker
                                v-model="col.coach_end_date"
                                type="month"
                                @focus="datePickerOfEnd(col)"
                                :picker-options="pickerOptionsEnd"
                                placeholder="请选择日期"
                                :value-format="'yyyy-MM'"
                                v-if="col.zhijin === 'N'"
                                style="width:150px;margin-left:20px"
                              >
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="地点" :prop="`coaching_Experience_not.${index}.coach_address`" :rules="isCoachExperienceNotExit ? [requiredItem('地点')] : []">
                              <el-input
                                v-model.trim="col.coach_address"
                                class="w220"
                                placeholder="请输入地点"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="单位名称" :prop="`coaching_Experience_not.${index}.unit_name`" :rules="isCoachExperienceNotExit ? [requiredItem('地点')] : []">
                              <el-input
                                v-model.trim="col.unit_name"
                                class="w220"
                                placeholder="请输入单位名称"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="职务" :prop="`coaching_Experience_not.${index}.coach_position`" :rules="isCoachExperienceNotExit ? [requiredItem('职务')] : []">
                              <el-input
                                v-model.trim="col.coach_position"
                                class="w220"
                                placeholder="请输入职务"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="证明人" :prop="`coaching_Experience_not.${index}.coach_references`" :rules="isCoachExperienceNotExit ? [requiredItem('证明人')] : []">
                              <el-input
                                v-model.trim="col.coach_references"
                                class="w220"
                                placeholder="请输入证明人"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="证明人职务" >
                              <el-input
                                v-model.trim="col.references_position"
                                class="w220"
                                placeholder="请输入证明人职务"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="联系方式" >
                              <el-input
                                v-model.trim="col.coach_contact_details"
                                class="w220"
                                placeholder="请输入联系方式"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="24">
                            <el-form-item label="主要经历" >
                              <el-input
                                style="width: 100%;"
                                v-model.trim="col.coach_achievements"
                                class=""
                                maxlength="200"
                                placeholder="请输入主要经历"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="10">
                          <el-col :span="24">
                            <el-form-item label="工作证明">
                              <el-row>
                                <el-col :span="12">
                                  <el-upload
                                    action="/api/enroll/upload_enroll_file.json"
                                    :file-list="col.work_certificate_list"
                                    :headers="fileUpHeaders"
                                    :data="fileUpParam"
                                    :limit="1"
                                    :before-upload="beforeUpload"
                                    :on-exceed="(file,  fileList) =>
                                      handleOnExceed(
                                          'coaching_Experience_not',
                                          index,
                                          file,
                                          fileList)
                                    "
                                    :on-remove="
                                      (file, fileList) =>
                                        handleRemoveFile(
                                          'coaching_Experience_not',
                                          index,
                                          file,
                                          fileList
                                        )
                                    "
                                    :on-success="
                                      (res, file) =>
                                        handleSuccessFile(
                                          'coaching_Experience_not',
                                          index,
                                          res,
                                          file
                                        )
                                    "
                                  >
                                    <el-button type="primary"
                                      >点击上传</el-button
                                    >
                                    <div slot="tip" class>请先<a href="/uploads/import_tpl/在职证明模板.docx" style="color: #4cd964" download="在职证明模板">下载在职证明模板</a>填写后上传，只能上传一个加盖公章后的PDF文件，且文件大小不能超过50M。（<a href="/uploads/import_tpl/在职证明示例.pdf" style="color: #4cd964" target="_blank">示例</a>）</div>
                                  </el-upload>
                                </el-col>
                                <el-col :span="10" v-if="col.work_certificate">
                                  <a
                                    :href="col.work_certificate"
                                    target="_black"
                                    ><el-button type="primary"
                                      >查看文件</el-button
                                    ></a
                                  >
                                </el-col>
                              </el-row>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="3">
                        <el-row class="exp-opt">
                          <el-col :span="8" >
                            <el-button
                              type="primary"
                              size="small"
                              icon="el-icon-plus"
                              circle
                              @click="addTeaExpNot"
                            ></el-button>
                            <!-- addTeaExpNotBefore(index) -->
                          </el-col>
                          <el-col :span="8" >
                            <el-button
                              v-show="
                                vitaForm.coaching_Experience_not.length !== 1
                              "
                              type="danger"
                              size="small"
                              icon="el-icon-minus"
                              title="删除"
                              circle
                              @click="delTeaExpNot(index)"
                            ></el-button>
                          </el-col>
                          <!-- <el-col :span="8" >
                            <el-button
                              type="success"
                              size="small"
                              icon="el-icon-plus"
                              title="向后插入"
                              @click="addTeaExpNotAfter(index)"
                            >向后插入</el-button>
                          </el-col> -->
                        </el-row>
                      </el-col>
                    </el-row>
                  </fieldset>

                  <!-- 讲师级别 -->
                  <!--<fieldset class="vita-form-fieldset" v-if="vitaForm.tea_present.level">-->
                    <!--<legend>讲师级别</legend>-->
                    <!--<el-row class="vita-edu-row" >-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="培训讲师最高级别" label-width="150px">-->
                          <!--<el-select v-model="vitaForm.tea_present.level" placeholder="请选择培训讲师最高级别" disabled>-->
                            <!--<el-option-->
                                    <!--v-for="item in taecherLevelSelect"-->
                                    <!--:key="item.key"-->
                                    <!--:label="item.key"-->
                                    <!--:value="item.value" >-->
                            <!--</el-option>-->
                          <!--</el-select>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                      <!--<el-col :span="9">-->
                        <!--<el-form-item label="资质获得时间" label-width="120px">-->
                          <!--<el-date-picker-->
                                  <!--v-model="vitaForm.tea_present.get_date"-->
                                  <!--type="month"-->
                                  <!--placeholder="选择日期">-->
                          <!--</el-date-picker>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                    <!--</el-row>-->
                    <!--<el-row class="vita-edu-row"  v-show="vitaForm.tea_present.level!='E' || vitaForm.tea_present.level!='early_assistant'">-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="培训讲师次级级别" label-width="150px">-->
                          <!--<el-select v-model="vitaForm.tea_previous.level" placeholder="请选择培训讲师次级级别" disabled>-->
                            <!--<el-option-->
                                    <!--v-for="item in taecherLevelSelect"-->
                                    <!--:key="item.key"-->
                                    <!--:label="item.key"-->
                                    <!--:value="item.value" >-->
                            <!--</el-option>-->
                          <!--</el-select>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="资质获得时间" label-width="120px">-->
                          <!--<el-date-picker-->
                                  <!--v-model="vitaForm.tea_previous.get_date"-->
                                  <!--type="month"-->
                                  <!--placeholder="选择日期">-->
                          <!--</el-date-picker>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                    <!--</el-row>-->
                    <!--<el-row class="vita-edu-row" v-if="!isFive">-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="专项讲师级别" label-width="150px">-->
                          <!--<el-select v-model="vitaForm.tea_special.level" placeholder="请选择专项讲师级别">-->
                            <!--<el-option-->
                                    <!--v-for="item in proLevellist"-->
                                    <!--:key="item.key"-->
                                    <!--:label="item.key"-->
                                    <!--:value="item.value">-->
                            <!--</el-option>-->
                          <!--</el-select>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                      <!--<el-col :span="12" >-->
                        <!--<el-form-item label="资质获得时间" label-width="120px">-->
                          <!--<el-date-picker-->
                                  <!--v-model="vitaForm.tea_special.level==='' ? '' : vitaForm.tea_special.get_date"-->
                                  <!--type="month"-->
                                  <!--clearable-->
                                  <!--placeholder="选择日期"-->
                                  <!--:disabled="!vitaForm.tea_special.level">-->
                          <!--</el-date-picker>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                    <!--</el-row>-->
                  <!--</fieldset>-->
                  <!-- 守门员讲师级别 -->
                  <!--<fieldset class="vita-form-fieldset" v-if="vitaForm.tea_present_g.level">-->
                    <!--<legend>守门员教练讲师级别</legend>-->
                    <!--<el-row class="vita-edu-row" >-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="培训讲师最高级别" label-width="150px">-->
                          <!--<el-select v-model="vitaForm.tea_present_g.level" placeholder="请选择培训讲师最高级别" disabled>-->
                            <!--<el-option-->
                                    <!--v-for="item in teacherLevelGoalkeeper"-->
                                    <!--:key="item.key"-->
                                    <!--:label="item.key"-->
                                    <!--:value="item.value" >-->
                            <!--</el-option>-->
                          <!--</el-select>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                      <!--<el-col :span="9">-->
                        <!--<el-form-item label="资质获得时间" label-width="120px">-->
                          <!--<el-date-picker-->
                                  <!--v-model="vitaForm.tea_present_g.get_date"-->
                                  <!--type="month"-->
                                  <!--placeholder="选择日期">-->
                          <!--</el-date-picker>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                    <!--</el-row>-->
                    <!--<el-row class="vita-edu-row" >-->
                    <!--&lt;!&ndash;  v-show="vitaForm.tea_present_g.level != 'GD'" &ndash;&gt;-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="培训讲师次级级别" label-width="150px">-->
                          <!--<el-select v-model="vitaForm.tea_previous_g.level" placeholder="请选择培训讲师次级级别" disabled>-->
                            <!--<el-option-->
                                    <!--v-for="item in teacherLevelGoalkeeper"-->
                                    <!--:key="item.key"-->
                                    <!--:label="item.key"-->
                                    <!--:value="item.value" >-->
                            <!--</el-option>-->
                          <!--</el-select>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                      <!--<el-col :span="12">-->
                        <!--<el-form-item label="资质获得时间" label-width="120px">-->
                          <!--<el-date-picker-->
                                  <!--v-model="vitaForm.tea_previous_g.get_date"-->
                                  <!--type="month"-->
                                  <!--placeholder="选择日期">-->
                          <!--</el-date-picker>-->
                        <!--</el-form-item>-->
                      <!--</el-col>-->
                    <!--</el-row>-->
                  <!--</fieldset>-->
                  <!-- 教练员级别 -->
                  <fieldset class="vita-form-fieldset">
                    <legend>教练员级别</legend>
                    <el-row v-for="(col, index) in vitaForm.coa_level_data" class="vita-edu-row">
                      <el-row>
                        <el-col :span="10"  >
                          <el-form-item label="教练员等级"
                                        label-width="120px">
                            <el-select v-model="col.level"
                                       placeholder="请选择教练员等级"
                            >
                              <el-option
                                      v-for="item in coachLevelSelect"
                                      :key="item.key"
                                      :label="item.key"
                                      :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col  :span="8"
                                 :offset="1"
                        >
                          <el-form-item label="资质获得时间"
                                        label-width="120px">
                            <el-date-picker
                                    v-model="col.aptitude_get_date"
                                    @change="changeColTime(index)"
                                    placeholder='请选择日期'
                            >
                            </el-date-picker>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="9"
                                :offset="1">

                          <el-form-item label="主讲师"
                                        label-width="85px">
                            <el-input v-model.trim="col.the_lecturer"
                                      placeholder="请输入主讲师"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8"
                                :offset="1"
                        >
                          <el-form-item label="培训地点"
                                        label-width="120px">
                            <el-input v-model.trim="col.train_address"
                                      placeholder="请输入培训地点"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="1"
                                :offset="1">
                          <el-button type="primary"
                                     size="small"
                                     icon="el-icon-plus"
                                     @click="addColLevel"
                                     circle></el-button>
                        </el-col>
                        <el-col :span="1"
                                :offset="1">
                          <el-button v-show="vitaForm.coa_level_data.length !== 1"
                                     type="danger"
                                     size="small"
                                     icon="el-icon-minus"
                                     @click="delColLevel(index)"
                                     circle></el-button>
                        </el-col>
                      </el-row>
                    </el-row>
                  </fieldset>

                  <!-- 等级教练员证书培训历程 -->
                  <!--<fieldset class="vita-form-fieldset">
                    <legend>等级教练员证书培训历程</legend>
                    <el-row v-for="(col, index) in vitaForm.coaching_qualification"
                            class="vita-edu-row">
                      <el-col :span="20">
                        <el-form-item label="起止日期">
                          <el-date-picker
                              v-model="col.time"
                              @change="changeTrainTime(index)"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="地点">
                              <el-input v-model.trim="col.train_address"
                                        placeholder="请输入地点"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="何等级">
                              <el-input v-model.trim="col.train_certificate"
                                        placeholder="请输入等级"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <el-form-item label="证书编号">
                              <el-input v-model.trim="col.certificate_number"
                                        placeholder="请输入证书编号"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="主讲师">
                              <el-input v-model.trim="col.train_references"
                                        placeholder="请输入主讲师"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="联系方式">
                              <el-input v-model.trim="col.train_contact_details"
                                        placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="4">
                        <el-row class="exp-opt">
                          <el-col :span="6"
                                  :offset="6">
                            <el-button type="primary"
                                       size="small"
                                       icon="el-icon-plus"
                                       @click="addTrainExp"
                                       circle></el-button>
                          </el-col>
                          <el-col :span="8"
                                  :offset="4">
                            <el-button v-show="vitaForm.coaching_qualification.length !== 1"
                                       type="danger"
                                       size="small"
                                       icon="el-icon-minus"
                                       @click="delTrainExp(index)"
                                       circle></el-button>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </fieldset>-->
                  
                  <fieldset class="vita-form-fieldset">
                    <legend>其他荣誉和经历</legend>
                    <el-row v-for="(col, index) in vitaForm.teacher_honor_experience"
                            class="vita-edu-row">
                      <el-col :span="20">
                        <el-form-item label="获得日期">
                          <el-date-picker
                                  v-model="col.get_date"
                                  @change="changeHonorTime(index)"
                                  placeholder="请选择日期"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-row>
                          <el-col :span="24">
                            <el-form-item label="荣誉和经历">
                              <el-input v-model.trim="col.honor_info"
                                        placeholder="请输入荣誉和经历"></el-input>
                            </el-form-item>
                          </el-col>

                        </el-row>
                      </el-col>
                      <el-col :span="4">
                        <el-row class="exp-opt">
                          <el-col :span="6"
                                  :offset="6">
                            <el-button type="primary"
                                       size="small"
                                       icon="el-icon-plus"
                                       @click="addHonor"
                                       circle></el-button>
                          </el-col>
                          <el-col :span="8"
                                  :offset="4">
                            <el-button v-show="vitaForm.teacher_honor_experience.length !== 1"
                                       type="danger"
                                       size="small"
                                       icon="el-icon-minus"
                                       @click="delHonor(index)"
                                       circle></el-button>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </fieldset>
                </el-form>
              </div>
            </vue-scroll>
          </template>
          <template v-else>
            <yioks-loading></yioks-loading>
          </template>
        </div>
        <div class="btns">
          <el-button type="primary"
                     @click="checkForm">保存
          </el-button>
          <el-button type="danger"
                     @click="makeSureBack">取消</el-button>
        </div>
        <yioks-tips :showTips="submitTips"
                    tips="确定保存吗？"
                    @hideTips="hideSubmitTips"></yioks-tips>
        <yioks-tips :showTips="backTips"
                    tips="确定放弃修改并返回吗？"
                    @hideTips="hideBackTips"></yioks-tips>
        <yioks-iKnow :showTips="iKnowTips" tips="电子相片要求为照相馆拍摄的本人清晰2寸白底证件照，将会用于教练员执照生成和人脸识别（翻拍或扫描相片、翻牌或扫描身份证照片、自拍照、非白底照、生活照、相片头顶无留白或不显示肩膀均为不合格）" @hideTips="iKnowHideTips"></yioks-iKnow>
      </div>
    </template>
  </form-main>
</template>

<script>
  import ops from "@/assets/js/vuescrollOption";
  import fieldMixin from "@/views/training_teacher/vita/mixin/data-field";
  import uploadMixin from "@/views/training_teacher/vita/mixin/upload-imgs";
  import optMixin from "@/views/training_teacher/vita/mixin/exp-options";
  import echoMixin from "@/views/training_teacher/vita/mixin/data-echo";
  import rulesMixin from "@/views/training_teacher/vita/mixin/form-rules";
  import {saveInfo} from "@/api/training_teacher/vita";
  import { mapMutations } from "vuex";
  import { proLevellist , qualificationList , teamList ,coach_experience,take_place ,sport_experience_Female,sport_experience_male,
    experienceNew,
    coach_experience_new,
    coach_experience_new_children1,
    coach_experience_new_children2,
    coach_experience_new_children3,
    coach_experience_new_children4,
    coach_position_list,
    take_unit_list,
    team_age_list,
    take_job_list,
    coach_experience_new_children5,
    coach_experience_new_children6,
    EnglishAbility} from "@/assets/js/select";
  import pinyin from '@/minix/pinyin'
  import fiveMixins from '@/minix/fiveMixins';
  import { requiredItem, isIdNumber } from "@/assets/js/formRules";
  import uploadForCommon from "@/minix/uploadMixin";
  import { checkPicture } from '@/api/common/api';

  export default {
    name: "vita",
    mixins: [fieldMixin, uploadMixin, optMixin, echoMixin, rulesMixin,pinyin, fiveMixins, uploadForCommon],
    data() {
      const shoesNum = [];
      for (let i = 0; ; i++) {
        const num = 35+0.5*i;
        if(num > 50) break;
        shoesNum.push(num);
      }
      const wearNum = ['S','M','L','XL','XXL','XXXL'];
      return {
        pickerStart: '',
        pickerEnd: '',
        shoesNum,
        take_unit_list,
        take_job_list,
        team_age_list,
        coach_experience_new_children5,
        coach_experience_new_children6,
        wearNum,
        ops: ops(),
        proLevellist,
        teamList,

        // tea_level: this.taecherLevelSelect,
        backTips: false,
        submitTips: false,
        iKnowTips: false,
        tmpLanguageRow: [],
        tmpEduExp: [],
        tmpTrainExp: [],
        tmpTeaExp: [],
        tmpSportsExp: [],
        colLevelData:[],
        honorExperience:[],
        userInfo: this.$store.state.userInfo,
        options: coach_experience,
        take_place:take_place,
        qualificationList,
        cascaderProps: { multiple: true, checkStrictly: true,  },
        isTackPalceExit: true,    // 是否存在执教场所
        stateTackPalce: [],   // 临时存储执教地点
        isCoachExperienceExit: true,
        stateCoachExperience:[],
        isSportExperienceExit: true,
        stateSportExperience: [],
        isCoachExperienceNotExit: true, // 是否存在其他工作经历
        stateCoachExperienceNot: [],

        isReload: true, // 强制更新
        experienceNew,
        coach_experience_new,
        coach_experience_new_children1,
        coach_experience_new_children2,
        coach_experience_new_children3,
        coach_experience_new_children4,
        coach_position_list,
        EnglishAbility: EnglishAbility,
        zhijin:false,
      };
    },
    components: {
      "form-main": () => import("@/components/LayOut/Common/up-down"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
      "vita-photo": () => import("@/components/UpImage/vita-upload"),
      "vita-img": () => import("@/components/UpImage/up-img"),
      "yioks-tips": () => import('@/components/Tips/Dialog'),
      "yioks-iKnow": () => import('@/components/Tips/iKnow'),
    },
    computed: {
      sport_experience_male() {
        return this.vitaForm.gender === 'Female' ? sport_experience_Female : sport_experience_male;
      },
      pickerOptionsEnd() {
        const pickerStart = this.pickerStart;
        if(pickerStart) {
          return {
            disabledDate(time) {
              return time.getTime() < Date.parse(pickerStart);
            },
          }
        } else {
          return {
            disabledDate(time) {
              return false ;
            },
          }
        }
      },
      pickerOptionsStart() {
        const pickerEnd = this.pickerEnd;
        if(pickerEnd) {
          return {
            disabledDate(time) {
              return time.getTime() > Date.parse(pickerEnd);
            },
          }
        } else {
          return {
            disabledDate(time) {
              return false ;
            },
          }
        }
        
      },
    },
    methods: {
      ...mapMutations(["updateUserInfo", "updateUserImg"]),
      requiredItem,
      getLevelList(val) {
        let level_list = [];
        if (val) {
          switch (val) {
            case "U6":
            case "U7":
            case "U8":
              level_list = coach_experience_new_children1;
              break;
            case "U9":
            case "U10":
            case "U11":
            case "U12":
              level_list = coach_experience_new_children2;
              break;
            case "U13":
            case "U14":
            case "U15（U16）":
              level_list = coach_experience_new_children5;
              break;
            case "U17（U18）":
            case "U19（U20）":
              level_list = coach_experience_new_children6;
              break;
            case "U21（预备队/大学队）":
              level_list = coach_experience_new_children3;
              break;
            case "一线队":
              level_list = coach_experience_new_children4;
              break;
          }
        }
        return level_list;
      },
      changeType(val, index) {
        this.vitaForm.coaching_Experience[index].team_level = "";
      },
      changeValue(value) {
        this.vitaForm.highest_experience_record = /^[0-9]*$/.test(parseInt(value)) ? String(parseInt(value)).replace(".", "") : ""
      },
      datePickerOfStart(val) {
        const { academic_end_date, academic_start_date, coach_end_date, coach_start_date,play_end_date,play_start_date } = val;
        if(academic_end_date){
          this.pickerEnd = academic_end_date;
        } else if(coach_end_date) {
          this.pickerEnd = coach_end_date;
        } else if(play_end_date) {
          this.pickerEnd = play_end_date;
        } else {
          this.pickerEnd = null;
        }
      },
      datePickerOfEnd(val) {
        const { academic_end_date, academic_start_date, coach_end_date, coach_start_date,play_end_date,play_start_date } = val;
        if(academic_start_date){
          this.pickerStart = academic_start_date;
        } else if(coach_start_date) {
          this.pickerStart = coach_start_date;
        } else if(play_start_date) {
          this.pickerStart = play_start_date;
        } else {
          this.pickerStart = null;
        }
      },
      reload() {
        this.isReload = false;
        // this.$nextTick(() => {
        //     this.isReload = true;
        // });
        setTimeout(() => {
          this.isReload = true;
        },1);
        this.$forceUpdate();
      },
      goBack() {
        this.$router.replace({
          path: "class_detail",
          query: {}
        });
      },
      makeSureBack() {
        this.backTips = true;
      },
      hideBackTips(bool, flag) {
        if (flag) {
          this.goBack();
        }
        this.backTips = bool;
      },
      checkForm() {
        let {tea_present, tea_present_g, tea_previous, tea_previous_g, tea_special} = this.vitaForm ;
        // 判断是否更改了时间
        tea_present.get_date= typeof tea_present.get_date ==='string' ?  tea_present.get_date : this.$yioks.time(tea_present.get_date,false);
        tea_previous.get_date= typeof tea_previous.get_date ==='string' ?  tea_previous.get_date : this.$yioks.time(tea_previous.get_date,false);
        tea_special.get_date= typeof tea_special.get_date ==='string' ?  tea_special.get_date : this.$yioks.time(tea_special.get_date,false);

        tea_present_g.get_date= typeof tea_present_g.get_date ==='string' ?  tea_present_g.get_date : this.$yioks.time(tea_present_g.get_date,false);
        tea_previous_g.get_date= typeof tea_previous_g.get_date ==='string' ?  tea_previous_g.get_date : this.$yioks.time(tea_previous_g.get_date,false);

        if (!this.vitaForm.id_card_photo_front) {
          this.$message({
            type: "error",
            message: "请上传身份证正面"
          });
          return;
        }
        if (!this.vitaForm.id_card_photo_verso) {
          this.$message({
            type: "error",
            message: "请上传身份证反面"
          });
          return;
        }
        if (!this.vitaForm.profile_picture) {
          this.$message({
            type: "error",
            message: "请上传二寸白底证件照"
          });
          return;
        }

        this.$refs["vitaForm"].validate((valid) => {
          if (valid) {
            this.translateData();
            this.makeSureSubmit();
          } else {
            this.$message({
              type: "error",
              message: "请完善所有带*号的必填项"
            });
            console.error('error submit!!');
            return false;
          }
        });
      },
      translateData() {
        // 出生日期转时间戳
        this.$set(this.vitaForm, "date_of_birth", new Date(this.vitaForm.date_of_birth).getTime());

        let {values} = Object;
        // 外语
        this.tmpLanguageRow = [];
        this.vitaForm.language_row.map((item) => {
          const flag = values(item).some((elem) => {
            return Boolean(elem);
          });
          // console.log("外语" + flag);
          flag && this.tmpLanguageRow.push(item);
        });
        this.tmpLanguageRow.length && this.$set(this.vitaForm, "language_row", this.tmpLanguageRow);

        // 教育经历
        this.tmpEduExp = [];
        this.vitaForm.academic_qualification.map((item) => {
          var _item = {...item};
          _item.zhijin='';
          const flag = values(_item).some((elem) => {
            return (elem instanceof Array) ? Boolean(elem.length) : Boolean(elem);
          });
          // console.log("教育经历" + flag);
          if (flag) {
            this.tmpEduExp.push(item);
          }
        });
        this.tmpEduExp.length && this.$set(this.vitaForm, "academic_qualification", this.tmpEduExp);

        // 执教经历
        this.tmpTeaExp = [];
        this.vitaForm.coaching_Experience.map((item) => {
          var _item = {...item};
          _item.zhijin='';
          const flag = values(_item).some((elem) => {
            return (elem instanceof Array) ? Boolean(elem.length) : Boolean(elem);
          });
          // console.log("执教经历" + flag);
          if (flag) {
            this.tmpTeaExp.push(item);
          }
        });
        this.tmpTeaExp.length && this.$set(this.vitaForm, "coaching_Experience", this.tmpTeaExp);

        // 其他工作经历
        this.tmpTeaExpNot = [];
        this.vitaForm.coaching_Experience_not.map((item) => {
          var _item = {...item};
          _item.zhijin='';
          const flag = values(_item).some((elem) => {
            return elem instanceof Array ? Boolean(elem.length) : Boolean(elem);
          });
          if (flag) {
            this.tmpTeaExpNot.push(item);
          }
        });
        this.tmpTeaExpNot.length &&
          this.$set(this.vitaForm, "coaching_Experience_not", this.tmpTeaExpNot);


        // 运动经历
        this.tmpSportsExp = [];
        this.vitaForm.playing_experience.map((item) => {
          var _item = {...item};
          _item.zhijin='';
          const flag = values(_item).some((elem) => {
            return (elem instanceof Array) ? Boolean(elem.length) : Boolean(elem);
          });
          // console.log("运动经历" + flag);
          if (flag) {
            this.tmpSportsExp.push(item);
          }
        });
        this.tmpSportsExp.length && this.$set(this.vitaForm, "playing_experience", this.tmpSportsExp);

        // 教练员级别
        this.colLevelData=[]

        this.vitaForm.coa_level_data.map((item) => {
          const flag = values(item).some((elem) => {
            return (elem instanceof Array) ? Boolean(elem.length) : Boolean(elem);
          });
          // console.log("运动经历" + flag);
          if (flag) {
            this.colLevelData.push(item);
          }
        });
        this.colLevelData.length && this.$set(this.vitaForm, "coa_level_data", this.colLevelData);

        //  其他荣誉和经历
        this.honorExperience=[]

        this.vitaForm.teacher_honor_experience.map((item) => {
          const flag = values(item).some((elem) => {
            return (elem instanceof Array) ? Boolean(elem.length) : Boolean(elem);
          });
          // console.log("运动经历" + flag);
          if (flag) {
            this.honorExperience.push(item);
          }
        });
        this.honorExperience.length && this.$set(this.vitaForm, "teacher_honor_experience", this.honorExperience);
      },

      makeSureSubmit() {
        var url = this.vitaForm.profile_picture;
        // 去掉http
        url = url.replace(/.*\/uploads/,"/uploads")
        if(this.not_allow_change){ // 不可更改的 就不校验白底图了
          this.submitTips = true;
        }else{
          // 检验是否白底图
          checkPicture({profile_picture:url}).then(({data}) => {
            // console.log(data);
            if (Number(data.status) === 0){
              let { isCheck, whiteBase } = data.result;
              if(isCheck && !whiteBase){
                this.iKnowTips = true;
                this.$refs.vitaImgInfo.deleteImg();
              }else{
                this.submitTips = true;
              }
            }else{
              this.submitTips = true;
            }
          })
          .catch((err) => {
            console.error(err);
            this.submitTips = true;
          });
        }
      },
      iKnowHideTips(bool,flag){
        this.iKnowTips=false;
      },
      hideSubmitTips(bool, flag) {
        if (flag) {
          this.submitForm();
        }
        this.submitTips = bool;
      },
      changePinyin(){
        this.vitaForm. given_name_spell='';
        this.$refs["vitaForm"].validateField("family_name_spell");
      },
      submitForm() {
        this.vitaForm.tea_present=JSON.stringify(this.vitaForm.tea_present)
        this.vitaForm.tea_present_g=JSON.stringify(this.vitaForm.tea_present_g)
        if(this.vitaForm.tea_previous.level===''){
          this.vitaForm.tea_previous=''
        }else{
          this.vitaForm.tea_previous=JSON.stringify(this.vitaForm.tea_previous)
        }
        if(this.vitaForm.tea_previous_g.level===''){
          this.vitaForm.tea_previous_g=''
        }else{
          this.vitaForm.tea_previous_g=JSON.stringify(this.vitaForm.tea_previous_g)
        }
        if(this.vitaForm.tea_special.level===''){
          this.vitaForm.tea_special=''
        }else{
          this.vitaForm.tea_special=JSON.stringify(this.vitaForm.tea_special)
        }
        const form = {
          ...this.vitaForm,
          language_row: JSON.stringify(this.tmpLanguageRow),
          academic_qualification: JSON.stringify(this.tmpEduExp),
          coaching_qualification: JSON.stringify(this.tmpTrainExp),
          coaching_Experience: this.isCoachExperienceExit ?  JSON.stringify(this.tmpTeaExp)  : [],
          playing_experience: this.isSportExperienceExit ? JSON.stringify(this.tmpSportsExp) : [],
          teacher_honor_experience:JSON.stringify(this.honorExperience),
          coa_level_data:JSON.stringify(this.colLevelData),
          coach_experience: this.vitaForm.coach_experience === '无' ? this.vitaForm.coach_experience : JSON.stringify(this.vitaForm.coach_experience),
          take_place: this.vitaForm.take_place === '无' ? this.vitaForm.take_place :JSON.stringify(this.vitaForm.take_place),
          coaching_Experience_not: this.isCoachExperienceNotExit ? JSON.stringify(this.tmpTeaExpNot) : [],
          is_coach_experience_not: this.isCoachExperienceNotExit ? 1 : 0,
          english_ability: this.vitaForm.english_ability, // 英语能力
          english_file: this.vitaForm.english_file, // 英语能力文件
          english_file_name: this.vitaForm.english_file_name, // 英语能力文件名
          english_ability_number: this.vitaForm.english_ability_number, // 英语能力
          sport_experience_new:this.vitaForm.sport_experience_new,
          is_goalkeeper:this.vitaForm.is_goalkeeper,
          highest_experience_record:['国家一线队','顶级职业联赛（中超/女超/海外顶级联赛）','第二级别联赛（中甲/女甲/海外次级别联赛）','第三级别联赛（中乙/女乙/海外第三级别联赛）','五人制职业联赛（五超/女五）','五人制第二级别联赛（五甲）'].includes(this.vitaForm.sport_experience_new) ? this.vitaForm.highest_experience_record : '',
          take_unit:this.vitaForm.take_unit,// 执教单位
          team_age:!['其他','未在执教'].includes(this.vitaForm.take_unit) ? this.vitaForm.team_age : "",// 队伍年龄
          team_sex:!['其他','未在执教'].includes(this.vitaForm.take_unit) ? this.vitaForm.team_sex : "",// 队伍性别
          take_job:!['其他','未在执教'].includes(this.vitaForm.take_unit) ? this.vitaForm.take_job : "",// 职务
          take_unit_name:this.vitaForm.take_unit_name,// 单位名称
        };
        saveInfo(form)
                .then(({data}) => {
                  // console.log(data);
                  if (Number(data.status) === 0) {
                    // vuex更新个人信息
                    const info = {
                      name: this.vitaForm.name.toUpperCase(),
                      mobile_phone: this.vitaForm.mobile_phone,
                      profile_picture: data.result.profile_picture,
                    };
                    this.$store.commit("updateUserInfo", {
                      ...this.userInfo,
                      ...info
                    });
                    this.$message.success("信息保存成功");
                    // 路由跳转
                    this.goBack();
                  }else if(Number(data.status) === 444) {
                    this.$message({
                      type: "error",
                      message: data.msg
                    });
                    this.emailErr = true;
                    this.emailMsg = data.msg;
                    this.$refs["vitaForm"].validateField("email_address");
                  }else{
                    this.$message.error(data.msg);
                  }
                })
                .catch((err) => {
                  console.error(err);
                });
      },
      querySearch(queryString, cb) {
        if (queryString.indexOf('@') > -1){
          cb([])
        }else{
          let res =[
            { "value": queryString + '@qq.com', "address": queryString + '@qq.com' },
            { "value": queryString + '@163.com', "address": queryString + '@163.com' },
            { "value": queryString + '@126.com', "address": queryString + '@126.com' },
            { "value": queryString + '@sina.com', "address": queryString + '@sina.com' },
            { "value": queryString + '@yioks.com', "address": queryString + '@yioks.com' },
            { "value": queryString + '@mail.com', "address": queryString + '@mail.com' },
            { "value": queryString + '@sohu.com', "address": queryString + '@sohu.com' },
            { "value": queryString + '@sogou.com', "address": queryString + '@sogou.com' },
          ]
          let  results = queryString ? res  : [];
          // 调用 callback 返回建议列表的数据
          cb(results);
        }
      },
      isZhijinChange(){
        this.$refs["vitaForm"].clearValidate();
        this.reload();
      },
      /* 执教场所变化 */
      isTackPalceExitChange(val) {
        this.$refs['vitaForm'].clearValidate()
        this.reload();
        if(!val) {
          this.stateTackPalce = this.vitaForm.take_place;
          this.$set(this.vitaForm, 'take_place', '无');
        }else {
          this.$set(this.vitaForm, 'take_place', this.stateTackPalce);
        }
      },

      /* 执教经历变化 */
      isCoachExperienceChange(val) {
        this.$refs['vitaForm'].clearValidate()
        this.reload();
        if(!val) {
          this.stateCoachExperience = this.vitaForm.coach_experience;
          this.$set(this.vitaForm, 'coach_experience', '无');
        }else {
          this.$set(this.vitaForm, 'coach_experience', this.stateCoachExperience);
        }
      },

      /* 执教经历变化 */
      isCoachExperienceNotChange(val) {
        this.$refs["vitaForm"].clearValidate();
        this.$forceUpdate();
        this.reload(); //stateSportExperienceNot 避免element中的一个报错信息，推测应该是代码某处逻辑对不存在dom赋值操作；没时间找具体问题了；先注释掉这里
        if (!val) {
          this.stateCoachExperienceNot = this.vitaForm.coach_experience_not;  // 没啥用。。。
          // this.$set(this.vitaForm, "coach_experience", "无");
        } else {
          // this.$set(this.vitaForm, "coach_experience", this.stateCoachExperienceNot);
        }
      },

      /* 运动经历 */
      isSportExperienceChange(val) {
        this.$refs['vitaForm'].clearValidate()
        this.reload();
        if (!val) {
          this.stateSportExperience = this.vitaForm.sport_experience_new;
          this.$set(this.vitaForm, "sport_experience_new", "无足球运动经历");
          this.$set(this.vitaForm, "is_goalkeeper", "否");
          this.$set(this.vitaForm, "highest_experience_record", "");
        } else {
          this.$set(this.vitaForm, "sport_experience_new", this.stateSportExperience);
        }
      },

      handleRemoveFile(itemName, index, file, fileList) {
      console.log(itemName, index, file, fileList);
      this.$nextTick(() => {
        this.vitaForm[itemName][index]["work_certificate"] = "";
      });
    },
    handleSuccessFile(itemName, index, res, fileList) {
      console.log(itemName, index, res, fileList);
      if (res.status === 0) {
        const {
          result: { document_name, document_url },
        } = res;
        this.$nextTick(() => {
          this.vitaForm[itemName][index]["work_certificate"] = document_url;
          this.vitaForm[itemName][index]["work_certificate_title"] =
            document_name;
          this.vitaForm[itemName][index]["work_certificate_list"] = [
            {
              name: document_name,
              url: document_url,
            },
          ];
        });
      }
    },
      handleRemoveFileEnglish( file, fileList) {
        this.$nextTick(() => {
          this.vitaForm.english_file = "";
        });
      },
      handleSuccessFileEnglish( res, fileList) {
        if (res.status === 0) {
          const {
            result: { document_name, document_url },
          } = res;
          this.$nextTick(() => {
            this.vitaForm.english_file = document_url;
            this.vitaForm.english_file_name = document_name;
            this.vitaForm.english_file_list = [
              {
                name: document_name,
                url: document_url,
              },
            ];
          });
        }
      },
    handleOnExceed(itemName, index, res, fileList) {
      this.$message.warning(`超出最大允许上传数量！`)
    },
    beforeUpload(file) {
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error("文件大小不能超过50M!");
        return false;
      }
      // if (!/^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i.test(file.name)) {
      if (!/^.*\.(pdf)$/i.test(file.name)) {
        this.$message.error("请上传pdf格式的文件!");
        return false;
      }
      let param = {
        document: file,
      }; // 多此一举？
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },
      handleOnExceedEnglish(res, fileList) {
        this.$message.warning(`超出最大允许上传数量！`)
      },
      beforeUploadEnglish(file) {
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error("文件大小不能超过50M!");
          return false;
        }
        // if (!/^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i.test(file.name)) {
        if (!/^.*\.(pdf)$/i.test(file.name)) {
          this.$message.error("请上传pdf格式的文件!");
          return false;
        }
        let param = {
          document: file,
        }; // 多此一举？
        for (const key in param) {
          if (param.hasOwnProperty(key)) {
            this.$set(this.fileUpParam, key, param[key]);
          }
        }
      },
    },
    watch:{
      // switch_pinyin:{
      //   handler(){
      //     //          this.vitaForm. family_name_spell='';
      //     this.vitaForm. given_name_spell='';
      //     this.$refs["vitaForm"].validateField("family_name_spell");
      //   }
      // }
    }
  }
</script>

<style lang="stylus">
  .vita-form-main {
    .content {
      .form-wrap {
        .el-form-item__label {
          color: #fff;
        }
        .vita-edu-row {
          .el-range-separator {
            padding: 0;
          }
        }
        $width = 306px;
        /*.birthday {
          .el-date-editor {
            width: $width;
          }
        }*/
        .gender, .national {
          .el-select {
            /*width: $width;*/
          }
        }
      }
    }
  }
</style>
<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  .vita-form-nav, .vita-form-main {
    flex: 1 1 auto;
    height: 100%;
  }

  .vita-form-nav {
    display: flex;
    align-items: center;
    p {
      font-size: $font_size_big;
    }
  }

  .vita-form-main {
    width: 100%;
    .content {
      height: calc(100% - 60px);
      padding: 20px 0;
      position: relative;
      background-color: $block_bg_color_base;
      .form-wrap {
        padding: 0 30px 0 25px;
        .vita-form-fieldset {
          margin: 0 0 20px 0;
          padding: 10px 10px 0;
          border: 1px solid $color_white;
          .photo {
            width: 132px;
            position: relative;
            cursor: pointer;
            .tips-photo {
              display: none;
              width: 345px;
              /*height: 220px;*/
              position: absolute;
              /*top: -30px;*/
              top: 160px;
              /*left: -250px;*/
              left: -180px;
              z-index: 100;
              img {
                width: 100%;
                height: 100%;
              }
            }
            &:hover {
              .tips-photo {
                display: block;
              }
            }
          }
          .idcard-front-end {
            width: 260px;
            position: relative;
            cursor: pointer;
            .front-end-tips {
              display: none;
              width: 345px;
              /*height: 170px;*/
              position: absolute;
              /*top: -5px;*/
              top: 160px;
              left: -40px;
              z-index: 100;
              /*&.front-tips {
                left: 260px;
              }
              &.end-tips {
                right: 260px;
              }*/
              img {
                width: 100%;
                height: 100%;
              }
            }
            &:hover {
              .front-end-tips {
                display: block;
              }
            }
          }
        }
        .vita-edu-row {
          margin: 0 0 10px 0;
          padding: 10px 0 0;
          border: 1px solid $color_white;
        }
        .exp-opt {
          padding: 60px 0 0;
          justify-content: space-between;
          display: flex;
        }
      }
    }
    .btns {
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      /*background-color: $color_err;*/
    }
  }
  .el-select {
    width: 100%;
  }
</style>
<style lang="stylus" >
  .basic_information_forbidden_click{
    cursor default !important
    .avatar-root .avatar-picture .avatar-uploader{
      cursor no-drop !important
    }
    .el-upload{
      cursor no-drop !important
    }
  }

  .double_line_cascader
    .el-cascader-menu:first-child
      .el-checkbox
        display none
  // .three_line_cascader
  //     .el-cascader-menu:not(:last-child)
  //         .el-checkbox
  //             display none
  .three_line_cascader
    .el-cascader-menu:nth-child(1), .el-cascader-menu:nth-child(2)
      .el-checkbox
        display none
  .vita-form-main
    .el-switch__label
      color #fff
    .el-switch__label--left
      &.is-active
        color #f56c6c
    .el-switch__label--right
      &.is-active
        color #4cd964
</style>
<style lang="stylus">
  .el-cascader{
    width : 100%
  }
  .my-wrapper-q
    .el-cascader-menu
      overflow-x:hidden
    .el-scrollbar__wrap
      overflow-x:hidden
    .el-scrollbar__wrap
      overflow-x hidden
  .el-scrollbar__wrap
    overflow-x hidden
.vita-form-main
  .el-upload-list__item-name
    color #fff !important
  .el-upload-list__item-name [class^="el-icon"]
    color #fff !important
  .el-radio--medium.is-bordered
    color white
</style>
